export const links = [
  {
    id: 1,
    url: "/",
    text: "Home",
  },
  {
    id: 2,
    url: "/repositories",
    text: "Repos",
  },
];

export const socialLinks = [
  {
    id: 2,
    url: "https://github.com/Tech-sensei",
    icon: "fab fa-github",
  },

  {
    id: 1,
    url: "https://twitter.com/Im_Tobilobah",
    icon: "fab fa-twitter",
  },

  {
    id: 3,
    url: "https://www.linkedin.com/in/tobiloba-ibraheem",
    icon: "fab fa-linkedin",
  },
];

export const mockUser = {
  login: "Tech-sensei",
  id: 87545908,
  node_id: "MDQ6VXNlcjg3NTQ1OTA4",
  avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/Tech-sensei",
  html_url: "https://github.com/Tech-sensei",
  followers_url: "https://api.github.com/users/Tech-sensei/followers",
  following_url:
    "https://api.github.com/users/Tech-sensei/following{/other_user}",
  gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/Tech-sensei/subscriptions",
  organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
  repos_url: "https://api.github.com/users/Tech-sensei/repos",
  events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/Tech-sensei/received_events",
  type: "User",
  site_admin: false,
  name: "Tobiloba Ibraheem",
  company: null,
  blog: "",
  location: "Nigeria,Lagos  ",
  email: null,
  hireable: null,
  bio: "I am both driven and self-motivated, and I am constantly experimenting with new technologies and techniques. I am very passionate about Web Development.",
  twitter_username: "Im_Tobilobah",
  public_repos: 29,
  public_gists: 0,
  followers: 62,
  following: 56,
  created_at: "2021-07-16T19:23:50Z",
  updated_at: "2023-02-28T14:20:04Z",
};

export const mockFollowers = [
  {
    login: "0xN0x",
    id: 1781547,
    node_id: "MDQ6VXNlcjE3ODE1NDc=",
    avatar_url: "https://avatars.githubusercontent.com/u/1781547?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/0xN0x",
    html_url: "https://github.com/0xN0x",
    followers_url: "https://api.github.com/users/0xN0x/followers",
    following_url: "https://api.github.com/users/0xN0x/following{/other_user}",
    gists_url: "https://api.github.com/users/0xN0x/gists{/gist_id}",
    starred_url: "https://api.github.com/users/0xN0x/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/0xN0x/subscriptions",
    organizations_url: "https://api.github.com/users/0xN0x/orgs",
    repos_url: "https://api.github.com/users/0xN0x/repos",
    events_url: "https://api.github.com/users/0xN0x/events{/privacy}",
    received_events_url: "https://api.github.com/users/0xN0x/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "gamemann",
    id: 6509565,
    node_id: "MDQ6VXNlcjY1MDk1NjU=",
    avatar_url: "https://avatars.githubusercontent.com/u/6509565?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/gamemann",
    html_url: "https://github.com/gamemann",
    followers_url: "https://api.github.com/users/gamemann/followers",
    following_url:
      "https://api.github.com/users/gamemann/following{/other_user}",
    gists_url: "https://api.github.com/users/gamemann/gists{/gist_id}",
    starred_url: "https://api.github.com/users/gamemann/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/gamemann/subscriptions",
    organizations_url: "https://api.github.com/users/gamemann/orgs",
    repos_url: "https://api.github.com/users/gamemann/repos",
    events_url: "https://api.github.com/users/gamemann/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/gamemann/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "AYIDouble",
    id: 18186995,
    node_id: "MDQ6VXNlcjE4MTg2OTk1",
    avatar_url: "https://avatars.githubusercontent.com/u/18186995?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/AYIDouble",
    html_url: "https://github.com/AYIDouble",
    followers_url: "https://api.github.com/users/AYIDouble/followers",
    following_url:
      "https://api.github.com/users/AYIDouble/following{/other_user}",
    gists_url: "https://api.github.com/users/AYIDouble/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/AYIDouble/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/AYIDouble/subscriptions",
    organizations_url: "https://api.github.com/users/AYIDouble/orgs",
    repos_url: "https://api.github.com/users/AYIDouble/repos",
    events_url: "https://api.github.com/users/AYIDouble/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/AYIDouble/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "androidmaven",
    id: 21104847,
    node_id: "MDQ6VXNlcjIxMTA0ODQ3",
    avatar_url: "https://avatars.githubusercontent.com/u/21104847?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/androidmaven",
    html_url: "https://github.com/androidmaven",
    followers_url: "https://api.github.com/users/androidmaven/followers",
    following_url:
      "https://api.github.com/users/androidmaven/following{/other_user}",
    gists_url: "https://api.github.com/users/androidmaven/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/androidmaven/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/androidmaven/subscriptions",
    organizations_url: "https://api.github.com/users/androidmaven/orgs",
    repos_url: "https://api.github.com/users/androidmaven/repos",
    events_url: "https://api.github.com/users/androidmaven/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/androidmaven/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Dmajor80",
    id: 39650616,
    node_id: "MDQ6VXNlcjM5NjUwNjE2",
    avatar_url: "https://avatars.githubusercontent.com/u/39650616?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Dmajor80",
    html_url: "https://github.com/Dmajor80",
    followers_url: "https://api.github.com/users/Dmajor80/followers",
    following_url:
      "https://api.github.com/users/Dmajor80/following{/other_user}",
    gists_url: "https://api.github.com/users/Dmajor80/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Dmajor80/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Dmajor80/subscriptions",
    organizations_url: "https://api.github.com/users/Dmajor80/orgs",
    repos_url: "https://api.github.com/users/Dmajor80/repos",
    events_url: "https://api.github.com/users/Dmajor80/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Dmajor80/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "harshit0209",
    id: 44460815,
    node_id: "MDQ6VXNlcjQ0NDYwODE1",
    avatar_url: "https://avatars.githubusercontent.com/u/44460815?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/harshit0209",
    html_url: "https://github.com/harshit0209",
    followers_url: "https://api.github.com/users/harshit0209/followers",
    following_url:
      "https://api.github.com/users/harshit0209/following{/other_user}",
    gists_url: "https://api.github.com/users/harshit0209/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/harshit0209/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/harshit0209/subscriptions",
    organizations_url: "https://api.github.com/users/harshit0209/orgs",
    repos_url: "https://api.github.com/users/harshit0209/repos",
    events_url: "https://api.github.com/users/harshit0209/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/harshit0209/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "isaacton",
    id: 45712236,
    node_id: "MDQ6VXNlcjQ1NzEyMjM2",
    avatar_url: "https://avatars.githubusercontent.com/u/45712236?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/isaacton",
    html_url: "https://github.com/isaacton",
    followers_url: "https://api.github.com/users/isaacton/followers",
    following_url:
      "https://api.github.com/users/isaacton/following{/other_user}",
    gists_url: "https://api.github.com/users/isaacton/gists{/gist_id}",
    starred_url: "https://api.github.com/users/isaacton/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/isaacton/subscriptions",
    organizations_url: "https://api.github.com/users/isaacton/orgs",
    repos_url: "https://api.github.com/users/isaacton/repos",
    events_url: "https://api.github.com/users/isaacton/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/isaacton/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Timmydee",
    id: 45721071,
    node_id: "MDQ6VXNlcjQ1NzIxMDcx",
    avatar_url: "https://avatars.githubusercontent.com/u/45721071?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Timmydee",
    html_url: "https://github.com/Timmydee",
    followers_url: "https://api.github.com/users/Timmydee/followers",
    following_url:
      "https://api.github.com/users/Timmydee/following{/other_user}",
    gists_url: "https://api.github.com/users/Timmydee/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Timmydee/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Timmydee/subscriptions",
    organizations_url: "https://api.github.com/users/Timmydee/orgs",
    repos_url: "https://api.github.com/users/Timmydee/repos",
    events_url: "https://api.github.com/users/Timmydee/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Timmydee/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Misturaht",
    id: 46754000,
    node_id: "MDQ6VXNlcjQ2NzU0MDAw",
    avatar_url: "https://avatars.githubusercontent.com/u/46754000?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Misturaht",
    html_url: "https://github.com/Misturaht",
    followers_url: "https://api.github.com/users/Misturaht/followers",
    following_url:
      "https://api.github.com/users/Misturaht/following{/other_user}",
    gists_url: "https://api.github.com/users/Misturaht/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/Misturaht/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Misturaht/subscriptions",
    organizations_url: "https://api.github.com/users/Misturaht/orgs",
    repos_url: "https://api.github.com/users/Misturaht/repos",
    events_url: "https://api.github.com/users/Misturaht/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Misturaht/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "habeebability",
    id: 49123641,
    node_id: "MDQ6VXNlcjQ5MTIzNjQx",
    avatar_url: "https://avatars.githubusercontent.com/u/49123641?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/habeebability",
    html_url: "https://github.com/habeebability",
    followers_url: "https://api.github.com/users/habeebability/followers",
    following_url:
      "https://api.github.com/users/habeebability/following{/other_user}",
    gists_url: "https://api.github.com/users/habeebability/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/habeebability/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/habeebability/subscriptions",
    organizations_url: "https://api.github.com/users/habeebability/orgs",
    repos_url: "https://api.github.com/users/habeebability/repos",
    events_url: "https://api.github.com/users/habeebability/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/habeebability/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "MuizzBakar",
    id: 49520914,
    node_id: "MDQ6VXNlcjQ5NTIwOTE0",
    avatar_url: "https://avatars.githubusercontent.com/u/49520914?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/MuizzBakar",
    html_url: "https://github.com/MuizzBakar",
    followers_url: "https://api.github.com/users/MuizzBakar/followers",
    following_url:
      "https://api.github.com/users/MuizzBakar/following{/other_user}",
    gists_url: "https://api.github.com/users/MuizzBakar/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/MuizzBakar/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/MuizzBakar/subscriptions",
    organizations_url: "https://api.github.com/users/MuizzBakar/orgs",
    repos_url: "https://api.github.com/users/MuizzBakar/repos",
    events_url: "https://api.github.com/users/MuizzBakar/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/MuizzBakar/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Jizzyjay",
    id: 51181625,
    node_id: "MDQ6VXNlcjUxMTgxNjI1",
    avatar_url: "https://avatars.githubusercontent.com/u/51181625?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Jizzyjay",
    html_url: "https://github.com/Jizzyjay",
    followers_url: "https://api.github.com/users/Jizzyjay/followers",
    following_url:
      "https://api.github.com/users/Jizzyjay/following{/other_user}",
    gists_url: "https://api.github.com/users/Jizzyjay/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Jizzyjay/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Jizzyjay/subscriptions",
    organizations_url: "https://api.github.com/users/Jizzyjay/orgs",
    repos_url: "https://api.github.com/users/Jizzyjay/repos",
    events_url: "https://api.github.com/users/Jizzyjay/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Jizzyjay/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "TunjiDev",
    id: 54449991,
    node_id: "MDQ6VXNlcjU0NDQ5OTkx",
    avatar_url: "https://avatars.githubusercontent.com/u/54449991?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/TunjiDev",
    html_url: "https://github.com/TunjiDev",
    followers_url: "https://api.github.com/users/TunjiDev/followers",
    following_url:
      "https://api.github.com/users/TunjiDev/following{/other_user}",
    gists_url: "https://api.github.com/users/TunjiDev/gists{/gist_id}",
    starred_url: "https://api.github.com/users/TunjiDev/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/TunjiDev/subscriptions",
    organizations_url: "https://api.github.com/users/TunjiDev/orgs",
    repos_url: "https://api.github.com/users/TunjiDev/repos",
    events_url: "https://api.github.com/users/TunjiDev/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/TunjiDev/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "titiodus",
    id: 59166113,
    node_id: "MDQ6VXNlcjU5MTY2MTEz",
    avatar_url: "https://avatars.githubusercontent.com/u/59166113?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/titiodus",
    html_url: "https://github.com/titiodus",
    followers_url: "https://api.github.com/users/titiodus/followers",
    following_url:
      "https://api.github.com/users/titiodus/following{/other_user}",
    gists_url: "https://api.github.com/users/titiodus/gists{/gist_id}",
    starred_url: "https://api.github.com/users/titiodus/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/titiodus/subscriptions",
    organizations_url: "https://api.github.com/users/titiodus/orgs",
    repos_url: "https://api.github.com/users/titiodus/repos",
    events_url: "https://api.github.com/users/titiodus/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/titiodus/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Chigael",
    id: 60928555,
    node_id: "MDQ6VXNlcjYwOTI4NTU1",
    avatar_url: "https://avatars.githubusercontent.com/u/60928555?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Chigael",
    html_url: "https://github.com/Chigael",
    followers_url: "https://api.github.com/users/Chigael/followers",
    following_url:
      "https://api.github.com/users/Chigael/following{/other_user}",
    gists_url: "https://api.github.com/users/Chigael/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Chigael/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Chigael/subscriptions",
    organizations_url: "https://api.github.com/users/Chigael/orgs",
    repos_url: "https://api.github.com/users/Chigael/repos",
    events_url: "https://api.github.com/users/Chigael/events{/privacy}",
    received_events_url: "https://api.github.com/users/Chigael/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "iOghenetega",
    id: 61510809,
    node_id: "MDQ6VXNlcjYxNTEwODA5",
    avatar_url: "https://avatars.githubusercontent.com/u/61510809?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/iOghenetega",
    html_url: "https://github.com/iOghenetega",
    followers_url: "https://api.github.com/users/iOghenetega/followers",
    following_url:
      "https://api.github.com/users/iOghenetega/following{/other_user}",
    gists_url: "https://api.github.com/users/iOghenetega/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/iOghenetega/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/iOghenetega/subscriptions",
    organizations_url: "https://api.github.com/users/iOghenetega/orgs",
    repos_url: "https://api.github.com/users/iOghenetega/repos",
    events_url: "https://api.github.com/users/iOghenetega/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/iOghenetega/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "charlzx",
    id: 63622840,
    node_id: "MDQ6VXNlcjYzNjIyODQw",
    avatar_url: "https://avatars.githubusercontent.com/u/63622840?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/charlzx",
    html_url: "https://github.com/charlzx",
    followers_url: "https://api.github.com/users/charlzx/followers",
    following_url:
      "https://api.github.com/users/charlzx/following{/other_user}",
    gists_url: "https://api.github.com/users/charlzx/gists{/gist_id}",
    starred_url: "https://api.github.com/users/charlzx/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/charlzx/subscriptions",
    organizations_url: "https://api.github.com/users/charlzx/orgs",
    repos_url: "https://api.github.com/users/charlzx/repos",
    events_url: "https://api.github.com/users/charlzx/events{/privacy}",
    received_events_url: "https://api.github.com/users/charlzx/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Adephumie",
    id: 64367471,
    node_id: "MDQ6VXNlcjY0MzY3NDcx",
    avatar_url: "https://avatars.githubusercontent.com/u/64367471?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Adephumie",
    html_url: "https://github.com/Adephumie",
    followers_url: "https://api.github.com/users/Adephumie/followers",
    following_url:
      "https://api.github.com/users/Adephumie/following{/other_user}",
    gists_url: "https://api.github.com/users/Adephumie/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/Adephumie/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Adephumie/subscriptions",
    organizations_url: "https://api.github.com/users/Adephumie/orgs",
    repos_url: "https://api.github.com/users/Adephumie/repos",
    events_url: "https://api.github.com/users/Adephumie/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Adephumie/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "ayvvla",
    id: 65915666,
    node_id: "MDQ6VXNlcjY1OTE1NjY2",
    avatar_url: "https://avatars.githubusercontent.com/u/65915666?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/ayvvla",
    html_url: "https://github.com/ayvvla",
    followers_url: "https://api.github.com/users/ayvvla/followers",
    following_url: "https://api.github.com/users/ayvvla/following{/other_user}",
    gists_url: "https://api.github.com/users/ayvvla/gists{/gist_id}",
    starred_url: "https://api.github.com/users/ayvvla/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/ayvvla/subscriptions",
    organizations_url: "https://api.github.com/users/ayvvla/orgs",
    repos_url: "https://api.github.com/users/ayvvla/repos",
    events_url: "https://api.github.com/users/ayvvla/events{/privacy}",
    received_events_url: "https://api.github.com/users/ayvvla/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "olatunde1998",
    id: 65951629,
    node_id: "MDQ6VXNlcjY1OTUxNjI5",
    avatar_url: "https://avatars.githubusercontent.com/u/65951629?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/olatunde1998",
    html_url: "https://github.com/olatunde1998",
    followers_url: "https://api.github.com/users/olatunde1998/followers",
    following_url:
      "https://api.github.com/users/olatunde1998/following{/other_user}",
    gists_url: "https://api.github.com/users/olatunde1998/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/olatunde1998/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/olatunde1998/subscriptions",
    organizations_url: "https://api.github.com/users/olatunde1998/orgs",
    repos_url: "https://api.github.com/users/olatunde1998/repos",
    events_url: "https://api.github.com/users/olatunde1998/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/olatunde1998/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "420-samm",
    id: 66690487,
    node_id: "MDQ6VXNlcjY2NjkwNDg3",
    avatar_url: "https://avatars.githubusercontent.com/u/66690487?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/420-samm",
    html_url: "https://github.com/420-samm",
    followers_url: "https://api.github.com/users/420-samm/followers",
    following_url:
      "https://api.github.com/users/420-samm/following{/other_user}",
    gists_url: "https://api.github.com/users/420-samm/gists{/gist_id}",
    starred_url: "https://api.github.com/users/420-samm/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/420-samm/subscriptions",
    organizations_url: "https://api.github.com/users/420-samm/orgs",
    repos_url: "https://api.github.com/users/420-samm/repos",
    events_url: "https://api.github.com/users/420-samm/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/420-samm/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "rahmlad-aramide",
    id: 67334984,
    node_id: "MDQ6VXNlcjY3MzM0OTg0",
    avatar_url: "https://avatars.githubusercontent.com/u/67334984?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/rahmlad-aramide",
    html_url: "https://github.com/rahmlad-aramide",
    followers_url: "https://api.github.com/users/rahmlad-aramide/followers",
    following_url:
      "https://api.github.com/users/rahmlad-aramide/following{/other_user}",
    gists_url: "https://api.github.com/users/rahmlad-aramide/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/rahmlad-aramide/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/rahmlad-aramide/subscriptions",
    organizations_url: "https://api.github.com/users/rahmlad-aramide/orgs",
    repos_url: "https://api.github.com/users/rahmlad-aramide/repos",
    events_url: "https://api.github.com/users/rahmlad-aramide/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/rahmlad-aramide/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "KP0124831432",
    id: 74746707,
    node_id: "MDQ6VXNlcjc0NzQ2NzA3",
    avatar_url: "https://avatars.githubusercontent.com/u/74746707?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/KP0124831432",
    html_url: "https://github.com/KP0124831432",
    followers_url: "https://api.github.com/users/KP0124831432/followers",
    following_url:
      "https://api.github.com/users/KP0124831432/following{/other_user}",
    gists_url: "https://api.github.com/users/KP0124831432/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/KP0124831432/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/KP0124831432/subscriptions",
    organizations_url: "https://api.github.com/users/KP0124831432/orgs",
    repos_url: "https://api.github.com/users/KP0124831432/repos",
    events_url: "https://api.github.com/users/KP0124831432/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/KP0124831432/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Kathy-kay",
    id: 75392925,
    node_id: "MDQ6VXNlcjc1MzkyOTI1",
    avatar_url: "https://avatars.githubusercontent.com/u/75392925?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Kathy-kay",
    html_url: "https://github.com/Kathy-kay",
    followers_url: "https://api.github.com/users/Kathy-kay/followers",
    following_url:
      "https://api.github.com/users/Kathy-kay/following{/other_user}",
    gists_url: "https://api.github.com/users/Kathy-kay/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/Kathy-kay/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Kathy-kay/subscriptions",
    organizations_url: "https://api.github.com/users/Kathy-kay/orgs",
    repos_url: "https://api.github.com/users/Kathy-kay/repos",
    events_url: "https://api.github.com/users/Kathy-kay/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Kathy-kay/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "adeyanjufawaz",
    id: 76100095,
    node_id: "MDQ6VXNlcjc2MTAwMDk1",
    avatar_url: "https://avatars.githubusercontent.com/u/76100095?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/adeyanjufawaz",
    html_url: "https://github.com/adeyanjufawaz",
    followers_url: "https://api.github.com/users/adeyanjufawaz/followers",
    following_url:
      "https://api.github.com/users/adeyanjufawaz/following{/other_user}",
    gists_url: "https://api.github.com/users/adeyanjufawaz/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/adeyanjufawaz/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/adeyanjufawaz/subscriptions",
    organizations_url: "https://api.github.com/users/adeyanjufawaz/orgs",
    repos_url: "https://api.github.com/users/adeyanjufawaz/repos",
    events_url: "https://api.github.com/users/adeyanjufawaz/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/adeyanjufawaz/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "oladips-design",
    id: 77060221,
    node_id: "MDQ6VXNlcjc3MDYwMjIx",
    avatar_url: "https://avatars.githubusercontent.com/u/77060221?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/oladips-design",
    html_url: "https://github.com/oladips-design",
    followers_url: "https://api.github.com/users/oladips-design/followers",
    following_url:
      "https://api.github.com/users/oladips-design/following{/other_user}",
    gists_url: "https://api.github.com/users/oladips-design/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/oladips-design/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/oladips-design/subscriptions",
    organizations_url: "https://api.github.com/users/oladips-design/orgs",
    repos_url: "https://api.github.com/users/oladips-design/repos",
    events_url: "https://api.github.com/users/oladips-design/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/oladips-design/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "hassana123",
    id: 77730541,
    node_id: "MDQ6VXNlcjc3NzMwNTQx",
    avatar_url: "https://avatars.githubusercontent.com/u/77730541?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/hassana123",
    html_url: "https://github.com/hassana123",
    followers_url: "https://api.github.com/users/hassana123/followers",
    following_url:
      "https://api.github.com/users/hassana123/following{/other_user}",
    gists_url: "https://api.github.com/users/hassana123/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/hassana123/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/hassana123/subscriptions",
    organizations_url: "https://api.github.com/users/hassana123/orgs",
    repos_url: "https://api.github.com/users/hassana123/repos",
    events_url: "https://api.github.com/users/hassana123/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/hassana123/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Samjolas",
    id: 80987604,
    node_id: "MDQ6VXNlcjgwOTg3NjA0",
    avatar_url: "https://avatars.githubusercontent.com/u/80987604?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Samjolas",
    html_url: "https://github.com/Samjolas",
    followers_url: "https://api.github.com/users/Samjolas/followers",
    following_url:
      "https://api.github.com/users/Samjolas/following{/other_user}",
    gists_url: "https://api.github.com/users/Samjolas/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Samjolas/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Samjolas/subscriptions",
    organizations_url: "https://api.github.com/users/Samjolas/orgs",
    repos_url: "https://api.github.com/users/Samjolas/repos",
    events_url: "https://api.github.com/users/Samjolas/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Samjolas/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Lhorla",
    id: 81013123,
    node_id: "MDQ6VXNlcjgxMDEzMTIz",
    avatar_url: "https://avatars.githubusercontent.com/u/81013123?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Lhorla",
    html_url: "https://github.com/Lhorla",
    followers_url: "https://api.github.com/users/Lhorla/followers",
    following_url: "https://api.github.com/users/Lhorla/following{/other_user}",
    gists_url: "https://api.github.com/users/Lhorla/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Lhorla/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Lhorla/subscriptions",
    organizations_url: "https://api.github.com/users/Lhorla/orgs",
    repos_url: "https://api.github.com/users/Lhorla/repos",
    events_url: "https://api.github.com/users/Lhorla/events{/privacy}",
    received_events_url: "https://api.github.com/users/Lhorla/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "chuka00",
    id: 81800355,
    node_id: "MDQ6VXNlcjgxODAwMzU1",
    avatar_url: "https://avatars.githubusercontent.com/u/81800355?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/chuka00",
    html_url: "https://github.com/chuka00",
    followers_url: "https://api.github.com/users/chuka00/followers",
    following_url:
      "https://api.github.com/users/chuka00/following{/other_user}",
    gists_url: "https://api.github.com/users/chuka00/gists{/gist_id}",
    starred_url: "https://api.github.com/users/chuka00/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/chuka00/subscriptions",
    organizations_url: "https://api.github.com/users/chuka00/orgs",
    repos_url: "https://api.github.com/users/chuka00/repos",
    events_url: "https://api.github.com/users/chuka00/events{/privacy}",
    received_events_url: "https://api.github.com/users/chuka00/received_events",
    type: "User",
    site_admin: false,
  },
];

export const mockRepos = [
  {
    id: 562567897,
    node_id: "R_kgDOIYga2Q",
    name: "Altschool-2nd-Semester-Exam",
    full_name: "Tech-sensei/Altschool-2nd-Semester-Exam",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Altschool-2nd-Semester-Exam",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-2nd-Semester-Exam/deployments",
    created_at: "2022-11-06T18:41:43Z",
    updated_at: "2022-11-06T20:33:46Z",
    pushed_at: "2022-11-06T20:55:49Z",
    git_url: "git://github.com/Tech-sensei/Altschool-2nd-Semester-Exam.git",
    ssh_url: "git@github.com:Tech-sensei/Altschool-2nd-Semester-Exam.git",
    clone_url: "https://github.com/Tech-sensei/Altschool-2nd-Semester-Exam.git",
    svn_url: "https://github.com/Tech-sensei/Altschool-2nd-Semester-Exam",
    homepage: "altschool-2nd-semester-exam-five.vercel.app",
    size: 1819,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 547025639,
    node_id: "R_kgDOIJry5w",
    name: "Altschool-Assignment-Calculator",
    full_name: "Tech-sensei/Altschool-Assignment-Calculator",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Altschool-Assignment-Calculator",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Altschool-Assignment-Calculator/deployments",
    created_at: "2022-10-07T02:53:16Z",
    updated_at: "2022-10-07T02:55:36Z",
    pushed_at: "2022-10-07T02:55:32Z",
    git_url: "git://github.com/Tech-sensei/Altschool-Assignment-Calculator.git",
    ssh_url: "git@github.com:Tech-sensei/Altschool-Assignment-Calculator.git",
    clone_url:
      "https://github.com/Tech-sensei/Altschool-Assignment-Calculator.git",
    svn_url: "https://github.com/Tech-sensei/Altschool-Assignment-Calculator",
    homepage: null,
    size: 292,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 599119805,
    node_id: "R_kgDOI7XXvQ",
    name: "altschool-class-of-vue-assignment",
    full_name: "Tech-sensei/altschool-class-of-vue-assignment",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url:
      "https://github.com/Tech-sensei/altschool-class-of-vue-assignment",
    description: null,
    fork: true,
    url: "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/altschool-class-of-vue-assignment/deployments",
    created_at: "2023-02-08T13:50:38Z",
    updated_at: "2023-02-08T18:49:21Z",
    pushed_at: "2023-02-08T18:49:16Z",
    git_url:
      "git://github.com/Tech-sensei/altschool-class-of-vue-assignment.git",
    ssh_url: "git@github.com:Tech-sensei/altschool-class-of-vue-assignment.git",
    clone_url:
      "https://github.com/Tech-sensei/altschool-class-of-vue-assignment.git",
    svn_url: "https://github.com/Tech-sensei/altschool-class-of-vue-assignment",
    homepage: null,
    size: 17,
    stargazers_count: 0,
    watchers_count: 0,
    language: "Vue",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 525394184,
    node_id: "R_kgDOH1DhCA",
    name: "altschool-opensource-names",
    full_name: "Tech-sensei/altschool-opensource-names",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/altschool-opensource-names",
    description:
      "we are testing out open source contribution during our live class",
    fork: true,
    url: "https://api.github.com/repos/Tech-sensei/altschool-opensource-names",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/altschool-opensource-names/deployments",
    created_at: "2022-08-16T13:34:52Z",
    updated_at: "2022-08-15T20:06:22Z",
    pushed_at: "2022-08-16T13:52:18Z",
    git_url: "git://github.com/Tech-sensei/altschool-opensource-names.git",
    ssh_url: "git@github.com:Tech-sensei/altschool-opensource-names.git",
    clone_url: "https://github.com/Tech-sensei/altschool-opensource-names.git",
    svn_url: "https://github.com/Tech-sensei/altschool-opensource-names",
    homepage: "https://altschool-opensource-names.oluwasetemi.dev/",
    size: 536,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 508050613,
    node_id: "R_kgDOHkg8tQ",
    name: "better-website",
    full_name: "Tech-sensei/better-website",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/better-website",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/better-website",
    forks_url: "https://api.github.com/repos/Tech-sensei/better-website/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/better-website/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/better-website/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/better-website/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/better-website/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/better-website/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/better-website/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/better-website/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/better-website/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/better-website/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/better-website/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/better-website/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/better-website/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/better-website/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/better-website/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/better-website/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/better-website/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/better-website/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/better-website/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/better-website/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/better-website/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/better-website/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/better-website/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/better-website/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/better-website/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/better-website/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/better-website/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/better-website/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/better-website/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/better-website/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/better-website/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/better-website/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/better-website/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/better-website/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/better-website/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/better-website/deployments",
    created_at: "2022-06-27T20:20:15Z",
    updated_at: "2022-07-20T13:40:30Z",
    pushed_at: "2022-06-27T20:36:27Z",
    git_url: "git://github.com/Tech-sensei/better-website.git",
    ssh_url: "git@github.com:Tech-sensei/better-website.git",
    clone_url: "https://github.com/Tech-sensei/better-website.git",
    svn_url: "https://github.com/Tech-sensei/better-website",
    homepage: null,
    size: 133,
    stargazers_count: 0,
    watchers_count: 0,
    language: "SCSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 519626191,
    node_id: "R_kgDOHvjdzw",
    name: "BetterPay-App",
    full_name: "Tech-sensei/BetterPay-App",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/BetterPay-App",
    description: "A payment App",
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/BetterPay-App",
    forks_url: "https://api.github.com/repos/Tech-sensei/BetterPay-App/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/BetterPay-App/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/BetterPay-App/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/BetterPay-App/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/BetterPay-App/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/BetterPay-App/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/BetterPay-App/deployments",
    created_at: "2022-07-30T21:42:37Z",
    updated_at: "2022-07-30T21:55:46Z",
    pushed_at: "2022-08-07T09:38:01Z",
    git_url: "git://github.com/Tech-sensei/BetterPay-App.git",
    ssh_url: "git@github.com:Tech-sensei/BetterPay-App.git",
    clone_url: "https://github.com/Tech-sensei/BetterPay-App.git",
    svn_url: "https://github.com/Tech-sensei/BetterPay-App",
    homepage: null,
    size: 344,
    stargazers_count: 0,
    watchers_count: 0,
    language: "SCSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 491449119,
    node_id: "R_kgDOHUrrHw",
    name: "Calculator",
    full_name: "Tech-sensei/Calculator",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Calculator",
    description: "HTML & CSS Calculator",
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Calculator",
    forks_url: "https://api.github.com/repos/Tech-sensei/Calculator/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/Calculator/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/Calculator/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/Calculator/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/Calculator/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/Calculator/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Calculator/deployments",
    created_at: "2022-05-12T09:32:26Z",
    updated_at: "2022-06-27T20:14:12Z",
    pushed_at: "2022-05-12T09:39:16Z",
    git_url: "git://github.com/Tech-sensei/Calculator.git",
    ssh_url: "git@github.com:Tech-sensei/Calculator.git",
    clone_url: "https://github.com/Tech-sensei/Calculator.git",
    svn_url: "https://github.com/Tech-sensei/Calculator",
    homepage: null,
    size: 2,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 526351623,
    node_id: "R_kgDOH199Bw",
    name: "circle-152-Phonie",
    full_name: "Tech-sensei/circle-152-Phonie",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/circle-152-Phonie",
    description: null,
    fork: true,
    url: "https://api.github.com/repos/Tech-sensei/circle-152-Phonie",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/circle-152-Phonie/deployments",
    created_at: "2022-08-18T19:42:42Z",
    updated_at: "2022-08-18T19:46:43Z",
    pushed_at: "2022-08-18T19:46:39Z",
    git_url: "git://github.com/Tech-sensei/circle-152-Phonie.git",
    ssh_url: "git@github.com:Tech-sensei/circle-152-Phonie.git",
    clone_url: "https://github.com/Tech-sensei/circle-152-Phonie.git",
    svn_url: "https://github.com/Tech-sensei/circle-152-Phonie",
    homepage: null,
    size: 132,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "development",
  },
  {
    id: 508046972,
    node_id: "R_kgDOHkgufA",
    name: "Delivery-Website",
    full_name: "Tech-sensei/Delivery-Website",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Delivery-Website",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Delivery-Website",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/Delivery-Website/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Delivery-Website/deployments",
    created_at: "2022-06-27T20:05:49Z",
    updated_at: "2022-06-27T20:07:23Z",
    pushed_at: "2022-06-27T20:07:20Z",
    git_url: "git://github.com/Tech-sensei/Delivery-Website.git",
    ssh_url: "git@github.com:Tech-sensei/Delivery-Website.git",
    clone_url: "https://github.com/Tech-sensei/Delivery-Website.git",
    svn_url: "https://github.com/Tech-sensei/Delivery-Website",
    homepage: null,
    size: 391,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 490446114,
    node_id: "R_kgDOHTudIg",
    name: "E-Commerce",
    full_name: "Tech-sensei/E-Commerce",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/E-Commerce",
    description: "Shoe Kits",
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/E-Commerce",
    forks_url: "https://api.github.com/repos/Tech-sensei/E-Commerce/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/E-Commerce/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/E-Commerce/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/E-Commerce/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/E-Commerce/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/E-Commerce/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/E-Commerce/deployments",
    created_at: "2022-05-09T21:12:06Z",
    updated_at: "2022-06-27T20:13:04Z",
    pushed_at: "2022-05-12T11:52:41Z",
    git_url: "git://github.com/Tech-sensei/E-Commerce.git",
    ssh_url: "git@github.com:Tech-sensei/E-Commerce.git",
    clone_url: "https://github.com/Tech-sensei/E-Commerce.git",
    svn_url: "https://github.com/Tech-sensei/E-Commerce",
    homepage: null,
    size: 492,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 514285155,
    node_id: "R_kgDOHqdeYw",
    name: "FlyBank-App",
    full_name: "Tech-sensei/FlyBank-App",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/FlyBank-App",
    description: "Fintech Dachboard App",
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/FlyBank-App",
    forks_url: "https://api.github.com/repos/Tech-sensei/FlyBank-App/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/FlyBank-App/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/FlyBank-App/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/FlyBank-App/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/FlyBank-App/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/FlyBank-App/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/FlyBank-App/deployments",
    created_at: "2022-07-15T13:46:22Z",
    updated_at: "2022-09-14T18:46:48Z",
    pushed_at: "2022-07-26T11:13:03Z",
    git_url: "git://github.com/Tech-sensei/FlyBank-App.git",
    ssh_url: "git@github.com:Tech-sensei/FlyBank-App.git",
    clone_url: "https://github.com/Tech-sensei/FlyBank-App.git",
    svn_url: "https://github.com/Tech-sensei/FlyBank-App",
    homepage: null,
    size: 920,
    stargazers_count: 0,
    watchers_count: 0,
    language: "SCSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 526774487,
    node_id: "R_kgDOH2Xw1w",
    name: "Forkify-App",
    full_name: "Tech-sensei/Forkify-App",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Forkify-App",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Forkify-App",
    forks_url: "https://api.github.com/repos/Tech-sensei/Forkify-App/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/Forkify-App/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/Forkify-App/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/Forkify-App/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/Forkify-App/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/Forkify-App/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Forkify-App/deployments",
    created_at: "2022-08-19T23:08:14Z",
    updated_at: "2022-09-11T08:46:59Z",
    pushed_at: "2022-09-14T16:51:43Z",
    git_url: "git://github.com/Tech-sensei/Forkify-App.git",
    ssh_url: "git@github.com:Tech-sensei/Forkify-App.git",
    clone_url: "https://github.com/Tech-sensei/Forkify-App.git",
    svn_url: "https://github.com/Tech-sensei/Forkify-App",
    homepage: null,
    size: 3335,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 508048343,
    node_id: "R_kgDOHkgz1w",
    name: "Forms",
    full_name: "Tech-sensei/Forms",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Forms",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Forms",
    forks_url: "https://api.github.com/repos/Tech-sensei/Forms/forks",
    keys_url: "https://api.github.com/repos/Tech-sensei/Forms/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Forms/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/Forms/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/Forms/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Forms/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/Forms/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Forms/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Forms/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/Forms/tags",
    blobs_url: "https://api.github.com/repos/Tech-sensei/Forms/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Forms/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Forms/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/Tech-sensei/Forms/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Forms/statuses/{sha}",
    languages_url: "https://api.github.com/repos/Tech-sensei/Forms/languages",
    stargazers_url: "https://api.github.com/repos/Tech-sensei/Forms/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Forms/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Forms/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Forms/subscription",
    commits_url: "https://api.github.com/repos/Tech-sensei/Forms/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Forms/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Forms/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Forms/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Forms/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Forms/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/Forms/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Forms/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/Tech-sensei/Forms/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Forms/issues{/number}",
    pulls_url: "https://api.github.com/repos/Tech-sensei/Forms/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Forms/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Forms/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/Tech-sensei/Forms/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Forms/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Forms/deployments",
    created_at: "2022-06-27T20:11:27Z",
    updated_at: "2022-06-27T20:12:06Z",
    pushed_at: "2022-06-27T20:12:03Z",
    git_url: "git://github.com/Tech-sensei/Forms.git",
    ssh_url: "git@github.com:Tech-sensei/Forms.git",
    clone_url: "https://github.com/Tech-sensei/Forms.git",
    svn_url: "https://github.com/Tech-sensei/Forms",
    homepage: null,
    size: 87,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 508047587,
    node_id: "R_kgDOHkgw4w",
    name: "Fox-Magazine-Web",
    full_name: "Tech-sensei/Fox-Magazine-Web",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Fox-Magazine-Web",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Fox-Magazine-Web/deployments",
    created_at: "2022-06-27T20:08:20Z",
    updated_at: "2022-06-27T20:10:52Z",
    pushed_at: "2022-06-27T20:10:49Z",
    git_url: "git://github.com/Tech-sensei/Fox-Magazine-Web.git",
    ssh_url: "git@github.com:Tech-sensei/Fox-Magazine-Web.git",
    clone_url: "https://github.com/Tech-sensei/Fox-Magazine-Web.git",
    svn_url: "https://github.com/Tech-sensei/Fox-Magazine-Web",
    homepage: null,
    size: 11181,
    stargazers_count: 0,
    watchers_count: 0,
    language: "SCSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 536719441,
    node_id: "R_kgDOH_2wUQ",
    name: "Frontend-Mentor",
    full_name: "Tech-sensei/Frontend-Mentor",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Frontend-Mentor",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Frontend-Mentor",
    forks_url: "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Frontend-Mentor/deployments",
    created_at: "2022-09-14T18:53:45Z",
    updated_at: "2022-09-14T18:54:15Z",
    pushed_at: "2022-09-14T18:54:11Z",
    git_url: "git://github.com/Tech-sensei/Frontend-Mentor.git",
    ssh_url: "git@github.com:Tech-sensei/Frontend-Mentor.git",
    clone_url: "https://github.com/Tech-sensei/Frontend-Mentor.git",
    svn_url: "https://github.com/Tech-sensei/Frontend-Mentor",
    homepage: null,
    size: 275,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 601113654,
    node_id: "R_kgDOI9RENg",
    name: "Github-User-App",
    full_name: "Tech-sensei/Github-User-App",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Github-User-App",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Github-User-App",
    forks_url: "https://api.github.com/repos/Tech-sensei/Github-User-App/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/Github-User-App/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/Github-User-App/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/Github-User-App/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Github-User-App/deployments",
    created_at: "2023-02-13T11:55:21Z",
    updated_at: "2023-02-13T11:56:17Z",
    pushed_at: "2023-02-13T14:40:06Z",
    git_url: "git://github.com/Tech-sensei/Github-User-App.git",
    ssh_url: "git@github.com:Tech-sensei/Github-User-App.git",
    clone_url: "https://github.com/Tech-sensei/Github-User-App.git",
    svn_url: "https://github.com/Tech-sensei/Github-User-App",
    homepage: null,
    size: 423,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 614010037,
    node_id: "R_kgDOJJkMtQ",
    name: "LRI",
    full_name: "Tech-sensei/LRI",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/LRI",
    description: null,
    fork: true,
    url: "https://api.github.com/repos/Tech-sensei/LRI",
    forks_url: "https://api.github.com/repos/Tech-sensei/LRI/forks",
    keys_url: "https://api.github.com/repos/Tech-sensei/LRI/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/LRI/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/LRI/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/LRI/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/LRI/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/LRI/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/LRI/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/LRI/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/LRI/tags",
    blobs_url: "https://api.github.com/repos/Tech-sensei/LRI/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/Tech-sensei/LRI/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/Tech-sensei/LRI/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/Tech-sensei/LRI/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/Tech-sensei/LRI/statuses/{sha}",
    languages_url: "https://api.github.com/repos/Tech-sensei/LRI/languages",
    stargazers_url: "https://api.github.com/repos/Tech-sensei/LRI/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/LRI/contributors",
    subscribers_url: "https://api.github.com/repos/Tech-sensei/LRI/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/LRI/subscription",
    commits_url: "https://api.github.com/repos/Tech-sensei/LRI/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/LRI/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/LRI/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/LRI/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/LRI/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/LRI/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/LRI/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/LRI/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/Tech-sensei/LRI/downloads",
    issues_url: "https://api.github.com/repos/Tech-sensei/LRI/issues{/number}",
    pulls_url: "https://api.github.com/repos/Tech-sensei/LRI/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/LRI/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/LRI/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/Tech-sensei/LRI/labels{/name}",
    releases_url: "https://api.github.com/repos/Tech-sensei/LRI/releases{/id}",
    deployments_url: "https://api.github.com/repos/Tech-sensei/LRI/deployments",
    created_at: "2023-03-14T17:56:02Z",
    updated_at: "2023-03-04T02:35:13Z",
    pushed_at: "2023-03-14T17:53:03Z",
    git_url: "git://github.com/Tech-sensei/LRI.git",
    ssh_url: "git@github.com:Tech-sensei/LRI.git",
    clone_url: "https://github.com/Tech-sensei/LRI.git",
    svn_url: "https://github.com/Tech-sensei/LRI",
    homepage: null,
    size: 8788,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 523850863,
    node_id: "R_kgDOHzlUbw",
    name: "Mapty-App",
    full_name: "Tech-sensei/Mapty-App",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Mapty-App",
    description: "A Geolocation App ",
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Mapty-App",
    forks_url: "https://api.github.com/repos/Tech-sensei/Mapty-App/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/Mapty-App/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/Mapty-App/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/Mapty-App/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/Mapty-App/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/Mapty-App/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Mapty-App/deployments",
    created_at: "2022-08-11T19:53:07Z",
    updated_at: "2022-08-11T19:58:08Z",
    pushed_at: "2022-08-11T19:58:04Z",
    git_url: "git://github.com/Tech-sensei/Mapty-App.git",
    ssh_url: "git@github.com:Tech-sensei/Mapty-App.git",
    clone_url: "https://github.com/Tech-sensei/Mapty-App.git",
    svn_url: "https://github.com/Tech-sensei/Mapty-App",
    homepage: null,
    size: 1967,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 573328956,
    node_id: "R_kgDOIixOPA",
    name: "Mavenfleet_Website",
    full_name: "Tech-sensei/Mavenfleet_Website",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Mavenfleet_Website",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Mavenfleet_Website/deployments",
    created_at: "2022-12-02T07:49:37Z",
    updated_at: "2023-02-24T16:31:20Z",
    pushed_at: "2023-03-09T14:20:30Z",
    git_url: "git://github.com/Tech-sensei/Mavenfleet_Website.git",
    ssh_url: "git@github.com:Tech-sensei/Mavenfleet_Website.git",
    clone_url: "https://github.com/Tech-sensei/Mavenfleet_Website.git",
    svn_url: "https://github.com/Tech-sensei/Mavenfleet_Website",
    homepage: null,
    size: 4177,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 1,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 604168020,
    node_id: "R_kgDOJALfVA",
    name: "My-Portfolio-Web",
    full_name: "Tech-sensei/My-Portfolio-Web",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/My-Portfolio-Web",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/My-Portfolio-Web/deployments",
    created_at: "2023-02-20T13:32:01Z",
    updated_at: "2023-02-20T13:33:53Z",
    pushed_at: "2023-02-20T13:33:48Z",
    git_url: "git://github.com/Tech-sensei/My-Portfolio-Web.git",
    ssh_url: "git@github.com:Tech-sensei/My-Portfolio-Web.git",
    clone_url: "https://github.com/Tech-sensei/My-Portfolio-Web.git",
    svn_url: "https://github.com/Tech-sensei/My-Portfolio-Web",
    homepage: null,
    size: 4004,
    stargazers_count: 0,
    watchers_count: 0,
    language: "SCSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 513782924,
    node_id: "R_kgDOHp-0jA",
    name: "personal-website",
    full_name: "Tech-sensei/personal-website",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/personal-website",
    description: "My Portfolio Website",
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/personal-website",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/personal-website/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/personal-website/deployments",
    created_at: "2022-07-14T06:17:55Z",
    updated_at: "2022-07-14T06:35:00Z",
    pushed_at: "2022-07-14T06:56:49Z",
    git_url: "git://github.com/Tech-sensei/personal-website.git",
    ssh_url: "git@github.com:Tech-sensei/personal-website.git",
    clone_url: "https://github.com/Tech-sensei/personal-website.git",
    svn_url: "https://github.com/Tech-sensei/personal-website",
    homepage: null,
    size: 3696,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 607707289,
    node_id: "R_kgDOJDjgmQ",
    name: "React-Projects",
    full_name: "Tech-sensei/React-Projects",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/React-Projects",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/React-Projects",
    forks_url: "https://api.github.com/repos/Tech-sensei/React-Projects/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/React-Projects/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/React-Projects/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/React-Projects/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/React-Projects/deployments",
    created_at: "2023-02-28T14:18:02Z",
    updated_at: "2023-02-28T14:18:59Z",
    pushed_at: "2023-02-28T14:18:52Z",
    git_url: "git://github.com/Tech-sensei/React-Projects.git",
    ssh_url: "git@github.com:Tech-sensei/React-Projects.git",
    clone_url: "https://github.com/Tech-sensei/React-Projects.git",
    svn_url: "https://github.com/Tech-sensei/React-Projects",
    homepage: null,
    size: 1294,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 559114900,
    node_id: "R_kgDOIVNqlA",
    name: "react-router-assignment-altschool",
    full_name: "Tech-sensei/react-router-assignment-altschool",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url:
      "https://github.com/Tech-sensei/react-router-assignment-altschool",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/react-router-assignment-altschool/deployments",
    created_at: "2022-10-29T05:17:51Z",
    updated_at: "2022-10-29T05:19:42Z",
    pushed_at: "2022-10-29T05:19:38Z",
    git_url:
      "git://github.com/Tech-sensei/react-router-assignment-altschool.git",
    ssh_url: "git@github.com:Tech-sensei/react-router-assignment-altschool.git",
    clone_url:
      "https://github.com/Tech-sensei/react-router-assignment-altschool.git",
    svn_url: "https://github.com/Tech-sensei/react-router-assignment-altschool",
    homepage: null,
    size: 327,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 586765559,
    node_id: "R_kgDOIvlU9w",
    name: "Shop-Buddy",
    full_name: "Tech-sensei/Shop-Buddy",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Shop-Buddy",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Shop-Buddy",
    forks_url: "https://api.github.com/repos/Tech-sensei/Shop-Buddy/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/Shop-Buddy/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/Shop-Buddy/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/Shop-Buddy/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/Shop-Buddy/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/Shop-Buddy/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Shop-Buddy/deployments",
    created_at: "2023-01-09T07:13:19Z",
    updated_at: "2023-01-09T07:13:57Z",
    pushed_at: "2023-02-27T06:26:32Z",
    git_url: "git://github.com/Tech-sensei/Shop-Buddy.git",
    ssh_url: "git@github.com:Tech-sensei/Shop-Buddy.git",
    clone_url: "https://github.com/Tech-sensei/Shop-Buddy.git",
    svn_url: "https://github.com/Tech-sensei/Shop-Buddy",
    homepage: null,
    size: 303,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 400587491,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDA1ODc0OTE=",
    name: "Tech-sensei",
    full_name: "Tech-sensei/Tech-sensei",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Tech-sensei",
    description: "Config files for my GitHub profile.",
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Tech-sensei",
    forks_url: "https://api.github.com/repos/Tech-sensei/Tech-sensei/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/Tech-sensei/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/Tech-sensei/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/Tech-sensei/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/Tech-sensei/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/Tech-sensei/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Tech-sensei/deployments",
    created_at: "2021-08-27T17:29:13Z",
    updated_at: "2022-08-10T20:43:07Z",
    pushed_at: "2022-08-10T20:40:21Z",
    git_url: "git://github.com/Tech-sensei/Tech-sensei.git",
    ssh_url: "git@github.com:Tech-sensei/Tech-sensei.git",
    clone_url: "https://github.com/Tech-sensei/Tech-sensei.git",
    svn_url: "https://github.com/Tech-sensei/Tech-sensei",
    homepage: "https://github.com/Divtoby",
    size: 3,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ["config", "github-config"],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 508049322,
    node_id: "R_kgDOHkg3qg",
    name: "TEDX-Event-Cloned",
    full_name: "Tech-sensei/TEDX-Event-Cloned",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/TEDX-Event-Cloned",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/TEDX-Event-Cloned/deployments",
    created_at: "2022-06-27T20:15:24Z",
    updated_at: "2022-06-27T20:16:58Z",
    pushed_at: "2022-06-27T20:16:55Z",
    git_url: "git://github.com/Tech-sensei/TEDX-Event-Cloned.git",
    ssh_url: "git@github.com:Tech-sensei/TEDX-Event-Cloned.git",
    clone_url: "https://github.com/Tech-sensei/TEDX-Event-Cloned.git",
    svn_url: "https://github.com/Tech-sensei/TEDX-Event-Cloned",
    homepage: null,
    size: 1385,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 521231545,
    node_id: "R_kgDOHxFcuQ",
    name: "TEDXOAU-2.0",
    full_name: "Tech-sensei/TEDXOAU-2.0",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/TEDXOAU-2.0",
    description: "TedxOAU Version 2.0",
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0",
    forks_url: "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/issues/events{/number}",
    events_url: "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/TEDXOAU-2.0/deployments",
    created_at: "2022-08-04T11:01:59Z",
    updated_at: "2022-08-04T11:26:55Z",
    pushed_at: "2022-08-04T23:19:05Z",
    git_url: "git://github.com/Tech-sensei/TEDXOAU-2.0.git",
    ssh_url: "git@github.com:Tech-sensei/TEDXOAU-2.0.git",
    clone_url: "https://github.com/Tech-sensei/TEDXOAU-2.0.git",
    svn_url: "https://github.com/Tech-sensei/TEDXOAU-2.0",
    homepage: null,
    size: 15049,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 508411547,
    node_id: "R_kgDOHk2-mw",
    name: "TEDxOAU_WEBPAGE",
    full_name: "Tech-sensei/TEDxOAU_WEBPAGE",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/TEDxOAU_WEBPAGE",
    description:
      "This is the build up to TEDxOAU webpage (built by Samuel Jolayemi and Tobiloba Ibrahim)",
    fork: true,
    url: "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE",
    forks_url: "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/teams",
    hooks_url: "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/branches{/branch}",
    tags_url: "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/TEDxOAU_WEBPAGE/deployments",
    created_at: "2022-06-28T18:25:08Z",
    updated_at: "2022-06-30T00:22:40Z",
    pushed_at: "2022-08-02T05:56:05Z",
    git_url: "git://github.com/Tech-sensei/TEDxOAU_WEBPAGE.git",
    ssh_url: "git@github.com:Tech-sensei/TEDxOAU_WEBPAGE.git",
    clone_url: "https://github.com/Tech-sensei/TEDxOAU_WEBPAGE.git",
    svn_url: "https://github.com/Tech-sensei/TEDxOAU_WEBPAGE",
    homepage: null,
    size: 22328,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 509705647,
    node_id: "R_kgDOHmF9rw",
    name: "Tobiloba-Ibraheem-Assignment-02",
    full_name: "Tech-sensei/Tobiloba-Ibraheem-Assignment-02",
    private: false,
    owner: {
      login: "Tech-sensei",
      id: 87545908,
      node_id: "MDQ6VXNlcjg3NTQ1OTA4",
      avatar_url: "https://avatars.githubusercontent.com/u/87545908?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/Tech-sensei",
      html_url: "https://github.com/Tech-sensei",
      followers_url: "https://api.github.com/users/Tech-sensei/followers",
      following_url:
        "https://api.github.com/users/Tech-sensei/following{/other_user}",
      gists_url: "https://api.github.com/users/Tech-sensei/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/Tech-sensei/starred{/owner}{/repo}",
      subscriptions_url:
        "https://api.github.com/users/Tech-sensei/subscriptions",
      organizations_url: "https://api.github.com/users/Tech-sensei/orgs",
      repos_url: "https://api.github.com/users/Tech-sensei/repos",
      events_url: "https://api.github.com/users/Tech-sensei/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/Tech-sensei/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/Tech-sensei/Tobiloba-Ibraheem-Assignment-02",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02",
    forks_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/forks",
    keys_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/teams",
    hooks_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/hooks",
    issue_events_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/events",
    assignees_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/tags",
    blobs_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/languages",
    stargazers_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/stargazers",
    contributors_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/contributors",
    subscribers_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/subscribers",
    subscription_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/subscription",
    commits_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/merges",
    archive_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/downloads",
    issues_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/labels{/name}",
    releases_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/Tech-sensei/Tobiloba-Ibraheem-Assignment-02/deployments",
    created_at: "2022-07-02T08:51:48Z",
    updated_at: "2022-07-02T08:51:52Z",
    pushed_at: "2022-07-08T11:21:22Z",
    git_url: "git://github.com/Tech-sensei/Tobiloba-Ibraheem-Assignment-02.git",
    ssh_url: "git@github.com:Tech-sensei/Tobiloba-Ibraheem-Assignment-02.git",
    clone_url:
      "https://github.com/Tech-sensei/Tobiloba-Ibraheem-Assignment-02.git",
    svn_url: "https://github.com/Tech-sensei/Tobiloba-Ibraheem-Assignment-02",
    homepage: null,
    size: 43,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    has_discussions: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: "public",
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
];
